// Static "Type" used to organize files. Stored on files.docType.
// Kept as plain strings so values can grow later.
export const DOC_TYPES = {
  GENERAL: 'General',
  RECIPE: 'Recipe',
  MANUAL: 'Manual',
  BREAD_MANUAL: 'Bread Manual',
  DRINKS_MANUAL: 'Drinks Manual',
  DESSERT_MANUAL: 'Dessert Manual',
  CAKE_MANUAL: 'Cake Manual',
};

export const DOC_TYPE_LIST = [
  DOC_TYPES.GENERAL,
  DOC_TYPES.RECIPE,
  DOC_TYPES.MANUAL,
  DOC_TYPES.BREAD_MANUAL,
  DOC_TYPES.DRINKS_MANUAL,
  DOC_TYPES.DESSERT_MANUAL,
  DOC_TYPES.CAKE_MANUAL,
];

// For dropdowns that select a value (upload/edit). labelText shows the literal value.
export const DOC_TYPE_OPTIONS = DOC_TYPE_LIST.map((v) => ({ labelText: v, value: v }));

export default DOC_TYPE_OPTIONS;
